import { CSSProperties } from "react";

export default {
    timelineContainer: { marginBottom: "80px" } as CSSProperties,
    highTrack: { zIndex: 2 } as CSSProperties
};
